import { CSProductDetails } from '@websrc/Typings/ContentStack'
import React, { forwardRef } from 'react'

import { table } from './ComparisonTable.css'
import { ComparisonTableProductHeading } from './ComparisonTableProductHeading'
import { ComparisonTableProductImage } from './ComparisonTableProductImage'
import { ComparisonTableSelectTr } from './ComparisonTableSelectTr'
import { isCellVisible } from './ComparisonTableUtils'

interface ComparisonTableStickyTheadProps {
  stickyBarHeight: number
  isSticky: boolean
  isMobile: boolean
  isTablet: boolean
  products: CSProductDetails[]
  setVisibleProductIndex: React.Dispatch<React.SetStateAction<number>>
  visibleProductIndex: number
}

export const ComparisonTableStickyThead = forwardRef<
  HTMLTableSectionElement,
  ComparisonTableStickyTheadProps
>(
  (
    {
      stickyBarHeight,
      isSticky,
      isMobile,
      isTablet,
      products,
      setVisibleProductIndex,
      visibleProductIndex,
    }: ComparisonTableStickyTheadProps,
    ref
  ) => {
    return (
      <thead
        className={table.thead.sticky._}
        ref={ref}
        style={{
          top: `${stickyBarHeight}px`,
          visibility: isSticky ? 'visible' : 'hidden',
          zIndex: isSticky ? '1' : '-1',
        }}
      >
        <ComparisonTableSelectTr
          isMobile={isMobile}
          products={products}
          setVisibleProductIndex={setVisibleProductIndex}
        />
        <tr>
          <th> </th>
          {products.map(
            (product, i) =>
              isCellVisible(i, visibleProductIndex, isMobile) && (
                <th className={table.thead.sticky.th} key={i}>
                  <div className={table.thead.sticky.desciption}>
                    {!isTablet && (
                      <div>
                        <ComparisonTableProductImage isSticky={true} product={product} />
                      </div>
                    )}
                    <div>
                      <ComparisonTableProductHeading isSticky={true} product={product} />
                    </div>
                  </div>
                </th>
              )
          )}
        </tr>
        <tr>
          <th colSpan={products.length + 1}>
            <div className={table.thead.sticky.border}> </div>
          </th>
        </tr>
      </thead>
    )
  }
)
